'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose([''], ['']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

var Heading = (0, _styledComponents2["default"])(_Text2["default"])(_templateObject);
Heading.defaultProps = {
  as: 'h2'
};
exports["default"] = Heading;
module.exports = exports['default'];